// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfirmDeleteTrendAlertModal_wrapper__wFAsF"};